import * as actions from '../sideBarActions';

const initialState = {
  leftSidebarOpen: true,
  // rightSidebarOpen: true,
};

const leftSideBarSet = (state, payload) => {
  state = Object.assign({}, state, {
    leftSidebarOpen: payload,
  });
  return state;
};

// const rightToggle = (state) => {
//     state = Object.assign({}, state, {
//         rightSidebarOpen: !state.rightSidebarOpen
//     });
//
//     return state;
// };

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.LEFT_SIDEBAR_TOGGLE:
      return leftSideBarSet(state, !state.leftSidebarOpen);
    case actions.LEFT_SIDEBAR_SET:
      return leftSideBarSet(state, payload);

    // case actions.RIGHT_SIDEBAR_TOGGLE:
    //     return rightToggle(state);
  }
  return state;
};
